import React, { useContext, useEffect, useState } from 'react';
import { changeWebPageTitleService } from '../../../infrastructure/services';
import { Private_Routes } from '../../../main/constants';
import { AppContext } from '../../../main/context/Provider';
import { AddButton } from '../../shared/components/AddButton';
import withFilteredQueryRequest from '../../shared/components/table/withFilteredRequest';
import ContactsTable from '../components/ContactsTable';
import { useParams } from 'react-router-dom';

export const ContactPage = () => {
    const { setNestedRoutes, isSkinSmart, lang } = useContext(AppContext);
    const { id } = useParams<{ id: string }>();

    const { webPage } = changeWebPageTitleService(isSkinSmart, 'Contactos');

    useEffect(() => {
        setNestedRoutes([
            {
                label: 'Clientes',
                route: Private_Routes.CUSTOMER_PAGE,
            },
            {
                label: 'Contactos',
                route: `/customers/contacts/contacts-list/${id}`,
            },
        ]);
    }, [lang]);

    const ContactsList = withFilteredQueryRequest(
        `contacts/contacts-list/${id}`,
        ContactsTable
    );

    return (
        <div className='row'>
            <div className='col-12'>
                <div className='card'>
                    <div className='card-body'>
                        <div className='mb-3'>
                            <AddButton href={Private_Routes.CREATE_CONTACT} />
                        </div>
                        <ContactsList />
                    </div>
                </div>
            </div>
        </div>
    );
};
